// Per-row "user provided the baseline at upload" flag (NSB #3/#7), keyed by sbKey
// (`${eventId}_${lineItemId}`). This is the in-memory mirror of the write-once
// `line_items.is_buyer_provided_baseline_price` column: populated once at import (in-session) and re-populated
// from the persisted column on every reload. It is NEVER flipped afterward, and — unlike
// userSelectedFlavorKeys — it is not cleared by
// dropdown / override changes (only on event change, then immediately re-hydrated). The NSB seeders read
// it to skip baselining user-provided rows; because the value is fixed, that guard is idempotent, so the
// engine's re-seed-on-selection-change effects can fire freely without ever clobbering the user's price.
import { registerNsbEventResetter } from './nsbEventReset';

const userProvidedKeys = new Set<string>();

export const setUserProvided = (sbKey: string | null): void => {
  if (sbKey) userProvidedKeys.add(sbKey);
};

export const isUserProvided = (sbKey: string | null): boolean => (sbKey ? userProvidedKeys.has(sbKey) : false);

// Cleared on every event change (see nsbEventReset); re-hydrated from the persisted column on load.
registerNsbEventResetter(() => userProvidedKeys.clear());
